import React, { useEffect } from "react";
import { useLocation } from "react-router";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Page404 from "go-app/components/Page404/Page404";
import RouteHistory from "go-core/utils/routeHistory";
import AppPage from "./pages/App";
import SecurityEmailConfirmedPage from "./pages/security/EmailConfirmed/EmailConfirmed";
import InvitationPage from "./pages/security/Invitation/InvitationPage";
import LoginPage from "./pages/security/Login/LoginPage";
import LoginCodePage from "./pages/security/LoginCode/LoginCodePage";
import SecurityLogoutPage from "./pages/security/Logout/LogoutPage";
import SecurityLostPasswordPage from "./pages/security/LostPassword/LostPasswordPage";
import SecurityRegisterPage from "./pages/security/Register/RegisterPage";
import ResetPasswordPage from "./pages/security/ResetPassword/ResetPasswordPage";
import SecuritySaveSessionPage from "./pages/security/SaveSessionId/SaveSessionPage";

const RouteChanges = () => {
	const location = useLocation();

	useEffect(() => {
		RouteHistory.set(location.pathname);
	}, [location.pathname]);
	return null;
};
const Routes = () => {
	return (
		<BrowserRouter>
			<Switch>
				<Route path="/login" component={LoginPage} />
				<Route path="/login_code" component={LoginCodePage} />
				<Route path="/lost-password" component={SecurityLostPasswordPage} />
				<Route path="/logout" component={SecurityLogoutPage} />
				<Route path="/verify_email_success" component={SecurityEmailConfirmedPage} />
				<Route path="/register" component={SecurityRegisterPage} />
				<Route path="/save_session_id" component={SecuritySaveSessionPage} />
				<Route path="/reset_password" component={ResetPasswordPage} />
				<Route path="/invitation" component={InvitationPage} />
				<Route path="/" component={AppPage} />
				<Route path="/404" component={Page404} />
				<Route component={Page404} />
			</Switch>
			<Route component={RouteChanges} />
		</BrowserRouter>
	);
};

export default Routes;
